export const SignupSelectorWeekly = {
  bindings: {
    isActive: '<',
    isDisabled: '<',
    product: '<',
    products: '<',
    text: '<',
    onChange: '&',
    onSelectBundle: '&',
  },

  template: `
    <div class="signup-weekly dropdown mb-4">
      <div class="px-3 px-md-5">
        <strong>Your Subscription</strong>
        <hr class="mt-1">
      </div>
      <div class="px-3 px-md-5">
        <div ng-repeat="product in $ctrl.products track by $index"
          ng-show="$ctrl.product.type === 'bundle' || $ctrl.product.id === product.id">
          <signup-tile-weekly
            color="$ctrl.text[product.name].color"
            icon="$ctrl.text[product.name].icon"
            is-bundle="$ctrl.product.type === 'bundle'"
            is-coupon="$ctrl.product.coupon !== undefined"
            price-in-cents="product.priceInCents"
            title="product.name"
            on-click="$ctrl.onChange({ product: product })">
          </signup-tile-weekly>
          <hr class="mt-3">
        </div>
        <table class="d-flex justify-content-end mb-3 w-100 signup-total">
          <tr ng-show="$ctrl.product.discountInCents">
            <td class="pr-3 pb-1">
              <strong>Was</strong>
            </td>
            <td></td>
            <td class="pl-1 pb-1">
              <strong>
                {{ $ctrl.product.priceInCents / 100 | currency }}/wk
              </strong>
            </td>
          </tr>
          <tr class="text-orange"
            ng-show="$ctrl.product.discountInCents">
            <td class="pr-3 pb-2">
              <strong>Bundle Saving 25%</strong>
            </td>
            <td class="pb-2">-</td>
            <td class="pl-1 pb-2">
              <strong>
                {{ $ctrl.product.discountInCents / 100 | currency }}
              </strong>
            </td>
          </tr>
          <tr>
            <td class="pr-3">
              <h5 class="text-black m-0">Weekly Cost</h5>
            </td>
            <td></td>
            <td class="pl-1">
              <h2 ng-class="{
                'text-orange': $ctrl.product.type === 'bundle',
                'text-black': $ctrl.product.type !== 'bundle'
              }">
                <signup-price value="$ctrl.product.totalInCents">
                </signup-price>
              </h2>
            </td>
          </tr>
          <tr ng-show="$ctrl.text[$ctrl.product.name].bundle && $ctrl.isActive">
            <td class="pt-4" colspan="3">
              <a href="#" ng-click="$ctrl.onSelectBundle()">
                {{ $ctrl.text[$ctrl.product.name].bundle }}
              </a>
            </td>
          </tr>
        </table>
      </div>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/components/Signup/SignupSelectorWeekly.js